import React, { Component } from 'react';
import axios from 'axios';

import {
    Modal, Form, Input, InputNumber, Select,
} from 'antd';

const FormItem = Form.Item;
const { Option } = Select;


class UnwrappedAddDocModal extends Component {
    state = {
        partners: [],
    }

    componentDidMount = () => {
        this.loadPartners();
    }

    loadPartners = () => {
        axios({
            method: 'get',
            url: '/partners.json',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                this.setState({ partners: response.data });
            })
            .catch((error) => {
                alert(`Internet Not working, Please check you connection: ${error.code}`);
            });
    };

    renderOptions = (id) => {
        const { partners } = this.state;

        if (id != null) {
            const filteredOption = partners.filter(partner => partner.id === id)[0].partner_locations;
            return filteredOption.map(opt => (
                <Option key={opt.id} value={opt.id}>{opt.name}</Option>
            ));
        }
        /*eslint-disable */
        return;
    }

    render() {
        const {
            visible, onCancel, onCreate, data, confirmLoading, form,
        } = this.props;

        const {
            partners,
        } = this.state;

        const { getFieldDecorator, getFieldValue } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 15 },
            },
        };

        const specialityArray = [
            'Cardiology', 'Neurology', 'Orthopedics', 'Pediatrics', 'Dermatology', 'Internal Medicine',
            'Radiology', 'Gynaecology', 'Ophthalmology', 'Oncology', 'Anaesthesiology', 'Gastroenterology',
            'Urology', 'Endocrinology', 'Physiotherapy', 'Emergency Med', 'Rheumatology', 'Pulmonology',
            'Infectious Diseases', 'Geriatrics', 'Hematology', 'Intensive Care', 'Nephrology', 'Nuclear Med',
            'Cardiothoracic Surgery', 'Genetics', 'Sleep Medicine', 'Colorectal Surgery', 'Pain Manangement',
            'Others',
        ];

        const specialityOptions = specialityArray.map(option => (
            <Option value={option}>{option}</Option>
        ));

        const qualificationsArray = ['MBBS', 'MS', 'MD', 'DM', 'BDS', 'BHMS', 'BAAS', 'BPT', 'Others'];

        const qualificationOptions = qualificationsArray.map(option => (
            <Option value={option}>{option}</Option>
        ));

        const partnerOptions = partners.map(partner => (
            <Option key={partner.id} value={partner.id}>{partner.name}</Option>
        ));

        return (
            <Modal
                visible={visible}
                title="Add new Doctor"
                style={{ textAlign: 'center', fontSize: '1.2em', top: 40 }}
                okText="Submit"
                confirmLoading={confirmLoading}
                onCancel={onCancel}
                onOk={onCreate}
            >

                <Form>

                    <div style={{ height: '580px', overflow: 'auto' }}>
                        <FormItem
                            {...formItemLayout}
                            label="Name"
                        >
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Name of Doctor?' }],
                                initialValue: data.name,
                            })(
                                <Input />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Mobile No"
                        >

                            {getFieldDecorator('mobile_number', {
                                rules: [{ required: false, message: 'Please input your phone number!' }],
                                initialValue: data.mobile_number,
                            })(
                                <InputNumber style={{ width: '100%' }} />,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 1"
                        >
                            {getFieldDecorator('partner1', {
                                rules: [{ required: true, message: 'Partner please!' }],
                            })(
                                <Select
                                    style={{ width: '100%' }}
                                    showSearch
                                    placeholder="Select a partner"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {partnerOptions}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 1 Locations"
                        >
                            {getFieldDecorator('partner1Locations', {
                                rules: [{ required: true, message: 'Partners Location please!' }],
                            })(
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Please select Locations"
                                >
                                    { this.renderOptions(getFieldValue('partner1')) }
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 2"
                        >
                            {getFieldDecorator('partner2', {
                                rules: [{ required: false, message: 'Partner please!' }],
                            })(
                                <Select
                                    style={{ width: '100%' }}
                                    showSearch
                                    onSelect={this.handleSelect2}
                                    placeholder="Select a partner"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {partnerOptions}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 2 Locations"
                        >
                            {getFieldDecorator('partner2Locations', {
                                rules: [{ required: false, message: 'Partners Location please!' }],
                            })(
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Please select Locations"
                                >
                                    { this.renderOptions(getFieldValue('partner2')) }
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 3"
                        >
                            {getFieldDecorator('partner3', {
                                rules: [{ required: false, message: 'Partner please!' }],
                            })(
                                <Select
                                    style={{ width: '100%' }}
                                    showSearch
                                    onSelect={this.handleSelect3}
                                    placeholder="Select a partner"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {partnerOptions}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 3 Locations"
                        >
                            {getFieldDecorator('partner3Locations', {
                                rules: [{ required: false, message: 'Partners Location please!' }],
                            })(
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Please select Locations"
                                >
                                    { this.renderOptions(getFieldValue('partner3')) }
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 4"
                        >
                            {getFieldDecorator('partner4', {
                                rules: [{ required: false, message: 'Partner please!' }],
                            })(
                                <Select
                                    style={{ width: '100%' }}
                                    showSearch
                                    onSelect={this.handleSelect4}
                                    placeholder="Select a partner"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {partnerOptions}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 4 Locations"
                        >
                            {getFieldDecorator('partner4Locations', {
                                rules: [{ required: false, message: 'Partners Location please!' }],
                            })(
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Please select Locations"
                                >
                                    { this.renderOptions(getFieldValue('partner4')) }
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 5"
                        >
                            {getFieldDecorator('partner5', {
                                rules: [{ required: false, message: 'Partner please!' }],
                            })(
                                <Select
                                    style={{ width: '100%' }}
                                    showSearch
                                    onSelect={this.handleSelect5}
                                    placeholder="Select a partner"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {partnerOptions}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Partner 5 Locations"
                        >
                            {getFieldDecorator('partner5Locations', {
                                rules: [{ required: false, message: 'Partners Location please!' }],
                            })(
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Please select Locations"
                                >
                                    { this.renderOptions(getFieldValue('partner5')) }
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Qualification"
                        >
                            {getFieldDecorator('qualification', {
                                rules: [{ required: false, message: 'Name of Doctor?' }],
                                initialValue: data.qualification,
                            })(
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    mode="combobox"
                                >
                                    {qualificationOptions}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Speciality"
                        >
                            {getFieldDecorator('speciality', {
                                rules: [{ required: false, message: 'Name of Doctor?' }],
                                initialValue: data.speciality,
                            })(
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    mode="combobox"
                                >
                                    {specialityOptions}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label="Registration Number"
                        >
                            {getFieldDecorator('registration_number', {
                                rules: [{ required: false, message: 'Name of Doctor?' }],
                                initialValue: data.registration_number,
                            })(
                                <Input />,
                            )}
                        </FormItem>

                    </div>

                </Form>

            </Modal>
        );
    }
}

const AddDocModal = Form.create()(UnwrappedAddDocModal);

export default AddDocModal;



// WEBPACK FOOTER //
// ./src/component/AddOrder/AddDocModal.js